const getExternalTooltipPercentageFormattedValue = ({ raw, total }) => {
  if (total === 0) {
    return `${raw} (0%)`;
  }

  return `${raw} (${String(
    parseFloat(((raw / total) * 100).toFixed(1))
  ).replace('.', ',')})%`;
};

export default getExternalTooltipPercentageFormattedValue;
